/* global grecaptcha */
const likeButtons = document.querySelectorAll("[data-like-button]");

function performLike(likeButton, reCaptchaToken, isLargeLikeButton = false) {
	const counterElement = document.querySelector(`[data-like-counter][data-subject-id="${likeButton.dataset.subjectId}"]`)

	let endpoint;
	likeButton.disabled = true;
	if (likeButton.dataset.liked !== undefined) {
		endpoint = "/likes/revokeLike";
		delete likeButton.dataset.liked;
		likeButton.dataset.likesCount = likeButton.dataset.likesCount*1 - 1;
	} else {
		endpoint = "/likes/addLike";
		likeButton.dataset.liked = true;
		likeButton.dataset.likesCount = likeButton.dataset.likesCount*1 + 1;
	}

	if (!isLargeLikeButton) likeButton.innerHTML = likeButton.dataset.likesCount;
	if (counterElement) counterElement.innerHTML = `${likeButton.dataset.likesCount} Gefällt mir`;

	let data = new URLSearchParams();
	data.set("subjectId", likeButton.dataset.subjectId);
	if (reCaptchaToken) {
		data.set("reCaptchaToken", reCaptchaToken);
	}
	fetch(endpoint, {
		method: "POST",
		credentials: "include",
		body: data
	}).then(function () {
		likeButton.disabled = false;
		document.body.dataset.isLoggedIn = true;
	}).catch(function () {
		console.error("Something went wrong while trying to vote");
		likeButton.disabled = false;
	});
}

likeButtons.forEach(function (likeButton) {
	if(document.querySelector('body').classList.contains('neos-backend')) {
		return;
	}
	likeButton.addEventListener("click", function () {
		const isLargeLikeButton = likeButton.classList.contains('large-like-button')
		if (document.body.dataset.isLoggedIn === undefined) {
			if (!window.grecaptcha) {
				window.alert("Du musst zuerst Cookies akzeptieren bevor du diese Funktion verwenden kannst!")
				return;
			}

			const websiteKey = document.body.dataset.recaptchaWebsiteKey;
			if(!websiteKey) {
				window.alert('reCaptcha wurde nicht korrekt konfiguriert!');
				console.error('websiteKey not set on the body');
				return;
			}

			if (!isLargeLikeButton) likeButton.innerHTML = '◌'; // loading
			grecaptcha.execute(websiteKey, {action: "like"}).then(function(reCaptchaToken) {
				console.info('recaptcha based login successful');
				performLike(likeButton, reCaptchaToken, isLargeLikeButton);
			});
		} else {
			performLike(likeButton, null, isLargeLikeButton);
		}
	});
});
